import React from 'react';

function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null; // Don't render the modal if it's not open

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-500 bg-opacity-75">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full overflow-auto max-h-[90vh]">
        <button onClick={onClose} className="absolute top-2 right-2 text-gray-500">
          ×
        </button>
        {children}
      </div>
    </div>
  );
}

export default Modal;
